export default {
  PUSH_NOTE: 'PUSH_NOTE',
  PUSH_NOTES: 'PUSH_NOTES',
  REMOVE_NOTE: 'REMOVE_NOTE',
  REPLACE_NOTE: 'REPLACE_NOTE',
  RESET_NOTE_STATE: 'RESET_NOTE_STATE',
  SET_ADDING_NOTE_FOR: 'SET_ADDING_NOTE_FOR',
  SET_IS_EDITING_NOTE: 'SET_IS_EDITING_NOTE',
  SET_NOTES_IS_LOADING: 'SET_NOTES_IS_LOADING',
  REPLACE_MY_NOTES: 'REPLACE_MY_NOTES',
};
